import { v4 as uuidv4 } from 'uuid';
import { PluginProvider } from '../../../system/providers/plugin';
import i18n from '../../../i18n';
import ActualPricesLotGridPluginSettings from './ActualPricesLotGridPluginSettings';
import ActualPricesLotPluginView from './ActualPricesLotPluginView';
import { CreateVariant } from '../../MasterTabsProvider';
import { typeReport } from '../DashboardBusinessControls/interfaces';

export const ActualPricesLotTab = (variant?: CreateVariant, idGlobal?: string, tabId?: string, contractorName?: string, reportType?: keyof typeof typeReport): ITab => {
    const getTabTitle = () => {
        function truncateString(str: string, maxLength: number): string {
            if (!str) return '';
            return str.length > maxLength
                ? `${str.substring(0, maxLength)}...`
                : str;
        }

        if (!reportType) return t("accounting.submenu.actualPrices");

        switch (reportType) {
            case 'ActualPrice':
                return `Доп. прибыль - ${truncateString(contractorName as string, 25)}`;            
            default:
                return t("accounting.submenu.actualPrices");
        }
    };
    const t = (value: string) => i18n.t("sidePanel." + value);
    return {
        id: uuidv4(),
        title: getTabTitle(),
        view: {
            content:    
            ActualPricesLotPluginView
                        ?   <PluginProvider plugin={ActualPricesLotGridPluginSettings()}>
                                <ActualPricesLotPluginView gridId={uuidv4()} plugin={ActualPricesLotGridPluginSettings()} tabId={tabId}/>
                            </PluginProvider>
                        : 
                        <p> Справочник не настроен </p>
        }
    }
}

export default ActualPricesLotTab
